import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withFeatureToggles } from 'shell/hoc/withFeatureToggles';
import { withBrowserHistory } from 'shell/hoc/withBrowserHistory';
import withUserGroupMembershipBOH from 'shell/hoc/withUserGroupMembershipBOH';
import mapProps from 'shell/hoc/mapProps';
import { GROUPS_MANAGEMENT } from 'constants/featureToggleNames';

import { fetchGroupClients, searchCentralClients, getGlobalClients } from '../../modules/clients/actions';
import ClientSearchModalNew from './ClientSearchModalNew';
import styles from './ClientSearchModalNew.styles';
import { getUngroupedClients, getRecentClients } from '../../modules/clients/selectors';

const mapStateToProps = ({ clientsModule }) => {
  return {
    clientList: getUngroupedClients(clientsModule),
    recentSearchList: getRecentClients(clientsModule),
    loading: clientsModule.clientsList.loading || clientsModule.clientsRecentList.loading,
    hasMore: clientsModule.clientsList.hasMore,
    showAddProfileButton: clientsModule.clientsList.showAddProfileButton,
  };
};

const mapDispatchToProps = {
  searchCentralClients,
  fetchGroupClients,
  getGlobalClients,
};

export default compose(
  withStyles(styles),
  withFeatureToggles({
    isGroupsManagementEnabled: GROUPS_MANAGEMENT,
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withUserGroupMembershipBOH(),
  withBrowserHistory(),
  mapProps(({ isBackOfHouseUser, ...restProps }) => {
    if (isBackOfHouseUser) {
      return {
        ...restProps,
        withTabs: false,
        isBackOfHouseUser,
      };
    }

    return restProps;
  }),
)(ClientSearchModalNew);
